import { VerificationI } from '../interfaces/verification.interface'
import { VerificationService } from '../services/verification.service'
import { VerificationGetSMSResponseT, VerificationGetTypesResponseT } from '../types/verification.types'

const verificationService = new VerificationService()

class VerificationRealisation implements VerificationI {
    sendSMS(payload: FormData): Promise<VerificationGetSMSResponseT> {
        return verificationService.sendSMS(payload)
    }

    sendSMSRepeat(payload: FormData): Promise<VerificationGetSMSResponseT> {
        return verificationService.sendSMSRepeat(payload)
    }

    confirm(payload: FormData): Promise<void> {
        return verificationService.confirm(payload)
    }

    getTypes(): Promise<VerificationGetTypesResponseT> {
        return verificationService.getTypes()
    }
}

export const verification = new VerificationRealisation()
